import {
  wrapPageElement as _wrapPageElement,
} from './src/utils/providers';

export const wrapPageElement = _wrapPageElement;

const isProduction = process.env.NODE_ENV === 'production';

export const onRouteUpdate = () => {
  if (!('serviceWorker' in window.navigator)) return;
  if (isProduction) {
    window.navigator.serviceWorker.register('/sw.js').then((reg) => {
      reg.update();
    });
  } else {
    // `gatsby develop` serves files left in public/ by a previous `gatsby build`,
    // so a production service worker would hijack the dev site with a stale shell.
    window.navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((reg) => reg.unregister());
    });
  }
};

// trigger an immediate page refresh when an update is found
export const onServiceWorkerUpdateReady = () => {
  window.location.reload();
};
